import updateHomepageSettingsSafety from '../../../actions/siteadmin/updateHomepageSettingsSafety'
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    await dispatch(updateHomepageSettingsSafety(values))
}

export default submit;